/* eslint-disable no-unused-vars */
import { ArrowLeftOutlined } from '@ant-design/icons'
import {
  Avatar,
  Button,
  Col,
  DatePicker,
  Divider,
  Row,
  Select,
  Table,
  Tabs,
  Tooltip,
  Typography,
} from 'antd'
import SimpleLinearRegression from 'ml-regression-simple-linear'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import swal from 'sweetalert'

import BarChart from '../../components/charts/Bar'
import Donought from '../../components/charts/Donought'
import LineChart from '../../components/charts/Line'
import Header from '../../components/Header'
import InvoiceModal from '../../components/modal/InvoiceDetail'
import { getOfflineCustomer, vendorLoyaltyByInvoice } from '../../redux'

import CommonBox from '../../components/CommonBox'
import {
  useGetAllFeedbackQuestion,
  useGetAllFeedbacks,
  useGetMobileNoFeedbacks,
} from '../../ReactQueryhooks/feedbackHooks'
// import { VendorLabels } from '../../config/VendorLabels'
import axios from 'axios'

const { TabPane } = Tabs

const CustomerDetails = () => {
  const { mobile } = useParams()
  const mode = useSelector((state) => state.generalReducer.mode)
  const singleUser = useSelector((state) => state.userReducer.singleUser)
  const vendorName = localStorage.getItem('vendorName')
  const vendorId = localStorage.getItem('vendorId')

  const [userOrders, setUserOrders] = useState([])

  const [fullOrders, setFullOrder] = useState([])
  const [discountOrders, setDiscountOrders] = useState([])
  const [refundedOrders, setRefundedOrders] = useState([])

  const [userOrdersCopy, setUserOrdersCopy] = useState([])
  const [productFrequency, setProductFrequency] = useState([])
  const [totalAmount, setTotalAmount] = useState(0)
  const [averageProductPurchasing, setAverageProductPurchasing] = useState(0)
  const [topProducts, setTopProducts] = useState([])
  const [InvoiceData, setInvoiceData] = []
  const [predictPrice, setPredictPrice] = useState([])

  const [predictionGraph, setPredictionGraph] = useState([])

  const [predictQuantity, setPredictQuantity] = useState([])

  const [monthsFilter, setMonthsFilter] = useState([])
  const [reset, setReset] = useState(false)

  const [purchasePeriod, setPurcahsePeriod] = useState(null)

  const [productBar, setProductBar] = useState([])
  const [orderBar, setOrderBar] = useState([])
  const [dicountPie, setDicountPie] = useState([])
  const [topProductGraph, setTopProductGraph] = useState([])
  const [spendingGraph] = useState([])
  const [resetGraph, setResetGraph] = useState(false)

  const dispatch = useDispatch()
  const [feedback, setFeedBack] = useState([])
  const [comments, setComments] = useState([])
  const [questions, setQuestions] = useState([])
  const [questionScores, setQuestionScores] = useState({})
  const [LoyaltyData, setLoyaltyData] = useState([])
  const [LoyaltyInvoiceData, setLoyaltyInvoiceData] = useState([])
  const getAllFeedbackMutateState = useGetMobileNoFeedbacks(dispatch)
  const getFeedbackQuestionMutateState = useGetAllFeedbackQuestion(dispatch)

  const getAllFeedbackData = () => {
    const payload = {
      mobile: mobile,
    }
    // console.log({ payload })
    getAllFeedbackMutateState.mutate(payload, {
      onSuccess: (data) => {
        // console.log({ data })
        setFeedBack(data?.message)
      },
    })
  }

  const getAllComments = () => {
    const commentsResp = feedback
      ?.filter((item) => item?.feedback?.Comments)
      ?.map((item) => {
        return {
          comments: item?.feedback?.Comments,
          date: moment(item?.createdAt).format('DD/MM/YYYY'),
        }
      })
    setComments(commentsResp)
  }

  const getAllQuestion = () => {
    getFeedbackQuestionMutateState.mutate(null, {
      onSuccess: (data) => {
        const resp = data?.message?.map((question) => {
          return question?.questions
        })
        const trimmedQuestion = resp?.[0]?.slice(0, -1)
        setQuestions(trimmedQuestion)
      },
    })
  }

  const calculateQuestionScores = () => {
    const scores = {}

    feedback.forEach((data) => {
      const feedbackData = data.feedback
      Object.keys(feedbackData).forEach((question) => {
        const rating = feedbackData[question]
        if (!scores[question]) {
          scores[question] = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
        }
        scores[question][rating]++
      })
    })

    setQuestionScores(scores)
  }

  const calculatePercentage = (question, rating) => {
    if (!questionScores[question] || !questionScores[question][rating]) return 0
    const totalCount = Object.values(questionScores[question])?.reduce(
      (acc, count) => acc + count,
      0,
    )
    const ratingCount = questionScores[question][rating]

    return (ratingCount / totalCount) * 100 || 0
  }

  useEffect(() => {
    getAllComments()
    getAllQuestion()
    calculateQuestionScores()
  }, [feedback])

  useEffect(() => {
    getAllFeedbackData()
    Loyalty()
    LoyaltyByInvoice()
  }, [])
  const resetValues = () => {
    setUserOrders([])
    setFullOrder([])
    setDiscountOrders([])
    setUserOrdersCopy([])
    setProductFrequency([])
    setTotalAmount(0)
    setAverageProductPurchasing(0)
    setTopProducts([])
    setPredictPrice([])
    setPredictionGraph([])
    setPredictQuantity([])
    setMonthsFilter([])
    setReset(false)
    setResetGraph(!resetGraph)
    setPurcahsePeriod(null)
    setProductBar([])
    setOrderBar([])

    window.document.body.scrollTop = 0
    window.document.documentElement.scrollTop = 0
  }

  useEffect(() => {
    dispatch(getOfflineCustomer(mobile))
  }, [])

  useEffect(() => {
    const offuserdetFun = async () => {
      setUserOrders(singleUser.sort((a, b) => new Date(a.dated) - new Date(b.dated)))
      setUserOrdersCopy(singleUser.sort((a, b) => new Date(a.dated) - new Date(b.dated)))

      let discounts = singleUser.filter((order) => {
        return order.netTotal >= 0 && order.invoiceTotal > order.netTotal
      })
      let full = singleUser.filter((order) => {
        return order.netTotal >= 0 && order.invoiceTotal <= order.netTotal
      })
      let refund = singleUser.filter((order) => {
        return order.netTotal < 0
      })

      let discountFull = []
      discountFull.push(
        {
          type: 'Full Payment Purchse',
          value: full.length,
        },
        {
          type: 'Discount Purchse',
          value: discounts.length,
        },
        {
          type: 'Refunded Orders',
          value: refund.length,
        },
      )
      setDicountPie(discountFull)

      setFullOrder(full)
      setDiscountOrders(discounts)
      setRefundedOrders(refund)

      let TotalAmount = 0
      let productNames = []
      let productFreqResult = []

      // eslint-disable-next-line
      singleUser?.map((orders) => {
        // eslint-disable-next-line
        orders?.products?.map((product) => {
          TotalAmount += product.netTotal
          const index = productNames.indexOf(product.productName)
          const { productName, price } = product
          if (index === -1) {
            let count = 0
            productNames.push(productName)
            productFreqResult.push({
              productName,
              price,
              count: (count += 1),
            })
          } else {
            productFreqResult[index].count += 1
          }
        })
      })
      setTotalAmount(TotalAmount.toFixed(2))
      setProductFrequency(productFreqResult)

      let topProducts = productFreqResult.sort((a, b) => b.count - a.count).slice(0, 5)
      setTopProducts(topProducts)

      let topGraph = []
      // eslint-disable-next-line
      topProducts.map((product) => {
        topGraph.push({
          type: product.productName,
          value: product.count,
        })
      })
      setTopProductGraph(topGraph)

      let barorder = []
      let purchasePeriodDates = []

      // eslint-disable-next-line
      singleUser.map((item) => {
        barorder.push({
          // date: moment(item.invoiceDate).format("Do MMM YYYY"),
          date: item.dated.slice(0, 10),
          amount: parseInt(item.netTotal === 0 ? item.invoiceTotal : item.netTotal),
        })
        purchasePeriodDates.push({
          date: item.dated,
        })
      })

      let barproduct = []
      productFreqResult &&
        // eslint-disable-next-line
        productFreqResult.map((item) => {
          barproduct.push({ product: item.productName, count: item.count })
        })
      setProductBar(barproduct)

      let totalProducts = 0
      // eslint-disable-next-line
      singleUser.map((order) => {
        totalProducts += order.products.length
      })
      setAverageProductPurchasing(Math.round(totalProducts / singleUser?.length))

      let DateArr = []
      let finalData = []

      // eslint-disable-next-line
      purchasePeriodDates.map((dataObj) => {
        const index = DateArr.indexOf(dataObj.date)
        if (index === -1) {
          DateArr.push(dataObj.date)
          finalData.push(dataObj.date)
        }
      })

      let dates = []
      let newDates = []
      // eslint-disable-next-line
      finalData.map((order) => {
        dates.push(order)
      })

      // eslint-disable-next-line
      dates.map((datea, i) => {
        const date1 = new Date(datea)
        const date2 = new Date(dates[i + 1])
        const diffTime = Math.abs(date2 - date1)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        newDates.push(diffDays)
      })

      newDates = newDates.filter(function (value) {
        return !Number.isNaN(value)
      })
      // newDates.pop();
      if (newDates.length === 0) {
        newDates = [1]
      }
      let addedDates =
        newDates.length > 0 &&
        newDates.reduce((a, b) => {
          return a + b
        })
      setPurcahsePeriod(Math.round(addedDates / singleUser?.length))

      let priceArr = []
      let quantityArr = []
      let x = []
      let y = []

      let x2 = []
      let y2 = []

      let period = Math.round(addedDates / singleUser?.length)
      let oneYearPeriod = 365 / period
      let gap = oneYearPeriod / 5
      let dayNewArr = []
      let tempValue = 0
      for (let i = 0; i < 5; i++) {
        let value = tempValue + gap
        tempValue = value
        dayNewArr.push(value)
      }

      let newRegArr = []
      let newQuantityArr = []

      // eslint-disable-next-line
      await singleUser?.map((order, i) => {
        y.push(order.netTotal)
        x.push(Number(order.dated.slice(8, 10)))
        // newRegArr.push([faltuArr[i], order.netTotal]);
        newRegArr.push([Number(order.dated.slice(8, 10)), order.netTotal])
      })

      // eslint-disable-next-line
      await singleUser?.map((order) => {
        let quantity = 0
        // eslint-disable-next-line
        order.products.map((product) => {
          quantity += product.quantity
        })
        y2.push(quantity)
        x2.push(Number(order.dated.slice(8, 10)))
        newQuantityArr.push([Number(order.dated.slice(8, 10)), quantity])
      })

      const purchaseResult = setPurchaseStatsGeneral(
        dates[0],
        dates[dates.length - 1],
        barorder,
        'date',
      )

      setOrderBar(purchaseResult)

      const priceRegression = new SimpleLinearRegression(x, y)
      const quantityRegression = new SimpleLinearRegression(x2, y2)

      const giveNewDate = (days) => {
        let tempDate = new Date(singleUser?.[singleUser.length - 1]?.dated || Date.now())
        tempDate?.setDate(tempDate.getDate() + days)
        return tempDate?.toISOString()?.slice(0, 10)
      }

      for (let i = 0; i <= 4; i++) {
        let dateArr = [15, 30, 60, 90, 365]

        priceArr.push({
          day: giveNewDate(dateArr[i]),
          price:
            dateArr[i] % period === 0
              ? Math.abs(priceRegression.predict(dayNewArr[i]).toFixed(2))
              : 0,
        })
      }

      for (let i = 0; i <= 4; i++) {
        let daysArr = [15, 30, 60, 90, 365]
        quantityArr.push({
          day: moment(giveNewDate(daysArr[i])).format('D MMM YYYY'),
          quantity:
            daysArr[i] % period === 0
              ? Math.round(Math.abs(quantityRegression.predict(dayNewArr[i]).toFixed(2)))
              : 0,
        })
      }

      const purchaseResult2 = setPurchaseStatsGeneral(
        dates[dates.length - 1],
        priceArr[priceArr.length - 1].day,
        priceArr,
        'day',
      )

      setPredictQuantity(quantityArr)
      setPredictPrice(priceArr)
      setPredictionGraph(purchaseResult2)
    }
    offuserdetFun()
    // eslint-disable-next-line
  }, [resetGraph, singleUser])
  // console.log('singleUser', singleUser)
  const setPurchaseStatsGeneral = (start, end, state, key) => {
    var startDate = new Date(start)
    var endDate = new Date(end)

    var getDateArray = function (start, end) {
      var arr = []
      while (start <= end) {
        arr.push(new Date(start).toISOString().slice(0, 10))
        start.setDate(start.getDate() + 1)
      }
      return arr
    }

    var datesArr = getDateArray(startDate, endDate)

    let continousData = []

    // eslint-disable-next-line
    datesArr.map((date) => {
      const obj = state.filter((order) => {
        return key === 'day' ? order.day === date : order.date === date
      })
      if (obj.length > 0) {
        // eslint-disable-next-line
        obj.map((object) => {
          continousData.push({
            date,
            amount: key === 'day' ? object.price : object.amount,
          })
        })
      } else {
        continousData.push({
          date,
          amount: 0,
        })
      }
    })

    return continousData

    // setOrderBar([...continousData]);
  }

  const columns = [
    {
      title: 'Invoice Date',
      dataIndex: 'invoiceDate',
    },
    {
      // title: VendorLabels.nippon['Invoice Number'],
      title: 'Invoice Number',
      dataIndex: 'invoiceNumber',
    },
    {
      title: 'Total',
      dataIndex: 'total',
      sorter: {
        compare: (a, b) => a.total.length - b.total.length,
        multiple: 3,
      },
    },
    {
      title: 'Net Total',
      dataIndex: 'netTotal',
      sorter: {
        compare: (a, b) => a.netTotal.length - b.netTotal.length,
        multiple: 3,
      },
    },
    {
      title: 'View Invoice',
      dataIndex: 'detail',
    },
  ]

  const productColumns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: 'No. of Times Bought',
      dataIndex: 'quantity',
      sorter: (a, b) => a.quantity - b.quantity,
    },
  ]

  const LoyaltyColumns = [
    {
      title: 'Name',
      dataIndex: 'customerName',
    },
    {
      title: 'Email',
      dataIndex: 'customerEmail',
    },
    {
      title: 'Address',
      dataIndex: 'customerAddress',
    },
    {
      title: 'City',
      dataIndex: 'customerCity',
    },
    {
      title: 'Date of Birth',
      dataIndex: 'dob',
    },
    {
      title: 'Loyalty Levels Name',
      dataIndex: 'loyaltyLevelsName',
    },
    {
      title: 'Current Loyalty Points',
      dataIndex: 'currentLoyaltyPoints',
    },
    {
      title: 'Amount',
      dataIndex: 'PKR',
    },
    {
      title: 'Promo Codes',
      dataIndex: 'vouchers',
      render: (t, obj) => {
        console.log('🚀 ~ obj:', obj)
        return (
          <p>
            {obj?.vouchers && Array.isArray(obj?.vouchers)
              ? obj?.vouchers?.map((v) => v['Voucher Code'])?.join(', ')
              : obj?.vouchers}
          </p>
        )
      },
    },
  ]

  const LoyaltyInvoiceColumns = [
    {
      title: 'Name',
      dataIndex: 'customerName',
    },
    {
      title: 'Phone',
      dataIndex: 'mobile',
    },
    {
      title: 'Invoice Number',
      dataIndex: 'invoiceNo',
    },
    {
      title: 'current Loyalty Points',
      dataIndex: 'current',
    },
    {
      title: 'Earned Loyalty Points',
      dataIndex: 'earned',
    },
    {
      title: 'Redeemed Loyalty Points',
      dataIndex: 'redeem',
    },
  ]
  const amountFormater = (value) => {
    value = value?.toString()
    const formatter = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return formatter
  }

  const dateOnChange = async (dates, dateStrings) => {
    await setUserOrders(userOrdersCopy)
    if (dateStrings[0] === '' && dateStrings[1] === '') {
      setUserOrders(userOrdersCopy)
      let barorder = []
      userOrdersCopy &&
        userOrdersCopy.length > 0 &&
        // eslint-disable-next-line
        userOrdersCopy.map((item) => {
          barorder.push({
            date: moment(item.dated).format('Do MMM YYYY'),
            // invoiceId: `Invoice ${item.invoiceId}`,
            amount: parseInt(item.netTotal),
          })
        })
      // setOrderBar(barorder);
      resetValues()
    } else {
      const filteredDateOrders = userOrders.filter((order) => {
        return (
          order.dated.slice(0, 10) >= dateStrings[0] && order.dated.slice(0, 10) <= dateStrings[1]
        )
      })
      setUserOrders(filteredDateOrders)
      let barorder = []
      filteredDateOrders &&
        filteredDateOrders.length > 0 &&
        // eslint-disable-next-line
        filteredDateOrders.map((item) => {
          barorder.push({
            date: item.dated.slice(0, 10),
            // invoiceId: `Invoice ${item.invoiceId}`,
            amount: parseInt(item.netTotal),
          })
        })
      let result = setPurchaseStatsGeneral(dateStrings[0], dateStrings[1], barorder, 'date')
      setOrderBar(result)
    }
  }

  const mostPurchasedOn = (data) => {
    let Dates = []
    let finalData = []

    // eslint-disable-next-line
    data.map((dataObj) => {
      const index = Dates.indexOf(dataObj.date)
      if (index === -1) {
        Dates.push(dataObj.date)
        finalData.push({
          date: dataObj.date,
          amount: dataObj.amount,
        })
      } else {
        let tempAmount = finalData[index].amount
        tempAmount = tempAmount + dataObj.amount
        finalData[index].amount = tempAmount
      }
    })
    let result = finalData.sort((a, b) => b.amount - a.amount).slice(0, 1)[0]
    // let date = new Date("4,Sep,2021").toDateString();
    // let newDate = result.date.split(" ");

    // return `${moment(result.date).format("LLLL")} (Rs. ${amountFormater(
    return `${result.date} (Rs. ${amountFormater(result.amount)})`
  }

  const monthlySummary = async () => {
    if (monthsFilter.length > 0) {
      let monthlyOrders = []

      // eslint-disable-next-line
      monthsFilter.map((month) => {
        userOrders &&
          // eslint-disable-next-line
          userOrders.map((order) => {
            let date = order.dated.slice(5, 7)
            if (date === month) {
              monthlyOrders.push(order)
            }
          })
      })

      if (monthlyOrders.length > 0) {
        setUserOrders(monthlyOrders)
        let barorder = []
        monthlyOrders &&
          monthlyOrders.length > 0 &&
          // eslint-disable-next-line
          monthlyOrders.map((item) => {
            barorder.push({
              date: item.dated.slice(0, 10),
              // invoiceId: `Invoice ${item.invoiceId}`,
              amount: parseInt(item.netTotal),
            })
          })

        let result = setPurchaseStatsGeneral(
          barorder[0].date,
          barorder[barorder.length - 1].date,
          barorder,
          'date',
        )
        setOrderBar(result)
        // setOrderBar(barorder);
      } else {
        setUserOrders([])
        setOrderBar([])
      }
    }
  }

  const resetMonthlyFilter = async () => {
    setUserOrders(userOrdersCopy)
    resetValues()

    // let barorder = [];
    // await userOrdersCopy.map((item) => {
    //   barorder.push({
    //     date: moment(item.invoiceDate).format("Do MMM YYYY"),
    //     // invoiceId: `Invoice ${item.invoiceId}`,
    //     amount: parseInt(item.netTotal),
    //   });
    // });
    // setOrderBar(barorder);
  }

  const monthlyRangeSummary = async (value) => {
    let currentDate = new Date()
    let previousDate = new Date()
    previousDate.setMonth(currentDate.getMonth() - value)

    const filteredDateOrders =
      userOrders &&
      userOrders.filter((order) => {
        return order.dated >= previousDate.toISOString() && order.dated <= currentDate.toISOString()
      })

    setUserOrders(filteredDateOrders)
    let barorder = []
    filteredDateOrders &&
      filteredDateOrders.length > 0 &&
      // eslint-disable-next-line
      filteredDateOrders.map((item) => {
        barorder.push({
          date: item.dated.slice(0, 10),
          amount: parseInt(item.netTotal),
        })
      })
    let result = setPurchaseStatsGeneral(
      previousDate.toISOString(),
      currentDate.toISOString(),
      barorder,
      'date',
    )
    setOrderBar(result)
  }

  const boxData = [
    {
      title: 'Total Orders',
      description: averageProductPurchasing * singleUser?.length,
    },
    {
      title: 'Total Invoices',
      description: singleUser?.length,
    },
    {
      title: 'Total Amount Spent',
      description: totalAmount && `Rs. ${amountFormater(Math.round(totalAmount))}`,
    },
    {
      title: 'Purchase Period',
      description: purchasePeriod && `${purchasePeriod} Days`,
    },
    {
      title: 'Average Spending',
      description:
        totalAmount && `Rs. ${amountFormater((totalAmount / userOrders.length)?.toFixed(0))}`,
    },
    {
      title: 'Average Products Purchasing',
      description: averageProductPurchasing && averageProductPurchasing,
    },
    {
      title: 'Full Payment Purchases',

      description: fullOrders && fullOrders.length > 0 ? fullOrders.length : '0',
    },
    {
      title: 'Discount Purchases',
      description: discountOrders && discountOrders.length > 0 ? discountOrders.length : '0',
    },
    {
      title: 'Last Purchase',
      description:
        userOrders &&
        userOrders.length > 0 &&
        ` ${moment(userOrders[userOrders.length - 1].dated).format('Do MMM YYYY')} (
          Rs. ${Math?.round(userOrders[userOrders.length - 1].netTotal)?.toLocaleString()}
        )`,
    },
    {
      title: 'Most Purchased On',
      description: orderBar && orderBar.length > 0 && mostPurchasedOn(orderBar),
    },
  ]

  const Loyalty = async () => {
    // await axios
    //   .post('https://doyalty.com/doyaltyv2/levis_apis/customerStatus.php', {
    //     mobile: mobile,
    //   })
    //   .then((result) => {
    //     // console.log('result.message', result)
    //     setLoyaltyData([result?.data])
    //   })
    //   .catch((error) => console.error('Error fecthing loyalty', error))
    if (vendorId === '897' || vendorId === '1003') {
      await axios
        .post(
          'https://doyalty.com/doyaltyv2/levis_apis/customerStatus.php',
          {
            mobile: mobile,
            merchantId: vendorId === '897' ? 4 : 7,
          },
          {
            headers: {
              Authorization:
                'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjUsImlhdCI6MTc0NTQyMjkxNywiZXhwIjoxNzQ4MDE0OTE3fQ.dr5LdE0ZApWQSFuJB7FwR1dFlh520snD47mwQ3AsHLw',
              'Content-Type': 'application/json',
            },
          },
        )
        .then((result) => {
          setLoyaltyData([result?.data])
        })
        .catch((error) => console.error('Error fecthing loyalty', error))
    }
  }

  console.log('[[[[', LoyaltyData)

  const LoyaltyByInvoice = async () => {
    // let tempArr = []
    const LoyaltyInvoiceWise = await vendorLoyaltyByInvoice(1, mobile)
    // .catch((error) => console.error('Error fecthing loyalty', error))
    setLoyaltyInvoiceData(LoyaltyInvoiceWise)
  }
  console.log('loyaltyInvoice', LoyaltyInvoiceData)

  return (
    <div>
      <Header />
      <div className='user-detail-main'>
        <div className='top-head'>
          {/* <Button
            shape='circle'
            icon={<ArrowLeftOutlined />}
            // onClick={() => navigate("/")}
            onClick={() => history.goBack()}
          /> */}
          <Typography.Title level={2}>Customer Profiling</Typography.Title>
        </div>

        <Row
          gutter={[30, 30]}
          style={{
            marginBottom: '2.5rem',
          }}
        >
          <Col xs={24} md={12} lg={6}>
            <div className='detail-section'>
              <div className='sec-1'>
                <Avatar
                  size={64}
                  style={{ color: '#fff', backgroundColor: '#8A1B6A' }}
                  // icon={<UserOutlined />}
                >
                  {/* {`${
                    singleData &&
                    singleData.userName &&
                    singleData.userName !== null
                      ? singleData.userName
                          .split(" ")
                          .map((name) => {
                            return name[0].toUpperCase();
                          })
                          .join("")
                      : "-"
                  }`} */}
                </Avatar>
                <Typography.Title level={5}>{mobile}</Typography.Title>
              </div>
              {/* <div className="sec-2">
                <Typography.Text>CONTACT DETAILS</Typography.Text>
                <div>
                  <p>
                    Email : <span>{singleData && singleData.eMail}</span>
                  </p>
                  <p>
                    Phone : <span>{singleData && singleData.mobile}</span>
                  </p>
                  <p>
                    Country : <span>-</span>
                  </p>
                  <p>
                    City : <span>-</span>
                  </p>
                </div>
              </div> */}
              <Divider type='vertical' />
              <div className='sec-2'>
                <Typography.Text>Name: {LoyaltyData?.[0]?.customerName}</Typography.Text>
              </div>
              <div className='sec-2'>
                <Typography.Text>Email: {LoyaltyData?.[0]?.customerEmail}</Typography.Text>
              </div>
              <div className='sec-2'>
                <Typography.Text>City: {LoyaltyData?.[0]?.customerCity}</Typography.Text>
              </div>
              <div className='sec-2'>
                <Typography.Text>Address: {LoyaltyData?.[0]?.customerAddress}</Typography.Text>
              </div>
              <div className='sec-2'>
                <Typography.Text>Date of Birth: {LoyaltyData?.[0]?.dob}</Typography.Text>
              </div>

              {/* <div>
                  <p>
                    Vendor Name : <span>{vendorName}</span>
                  </p>
                </div> */}
              {/* <Divider type='vertical' />
              <div className='sec-2'>
                <Typography.Text>OTHER INFO</Typography.Text>
                <div>
                  <p>
                    Mobile : <span>{mobile}</span>
                  </p> */}
              {/* <p>
                    Member Since :{" "}
                    <span>
                      {singleData &&
                      singleData.memberSince &&
                      singleData.memberSince !== null
                        ? moment(singleData.memberSince).format("Do MM Y")
                        : "-"}
                    </span>
                  </p> */}
              {/* <p>
                Average Spend :{" "}
                <span>
                  around{" "}
                  {amountFormater((totalAmount / userOrders.length).toFixed(2))}
                </span>
              </p> */}
              {/* <p>
                    Base Vendor :{" "}
                    <span>
                      {
                        singleData && singleData.base_vendor
                        // ? singleData.base_vendor
                        // : vendorName
                      }
                    </span>
                  </p> */}
              {/* </div> */}
              {/* </div> */}
            </div>
          </Col>
          <Col xs={24} md={12} lg={18}>
            <Row gutter={[20, 20]}>
              <Col xs={24}>
                <Row className='top-stats graph-card' gutter={[30, 30]}>
                  {boxData?.map((data, index) => (
                    <Col key={index} xs={24} md={12} lg={8}>
                      <CommonBox title={data?.title} description={data?.description} />
                    </Col>
                  ))}
                </Row>
              </Col>
              {/* <Col xs={24}>
                <div className='graph-card'>
                  <Typography.Title level={5} style={{ marginBottom: '1.25rem' }}>
                    User Orders Stats
                  </Typography.Title>
                  <LineChart data={orderBar} />
                </div>
              </Col> */}
            </Row>
          </Col>
        </Row>

        {/* <div className="detail-section">
          <div className="sec-1">
            <Avatar
              size={64}
              style={{ color: "#fff", backgroundColor: "#8A1B6A" }}
              // icon={<UserOutlined />}
            >
              {`${
                singleData &&
                singleData.userName &&
                singleData.userName !== null &&
                singleData.userName
                  .split(" ")
                  .map((name) => {
                    return name[0].toUpperCase();
                  })
                  .join("")
              }`}
            </Avatar>
            <Typography.Title level={5}>{`${
              singleData && singleData.userName !== null && singleData.userName
            }`}</Typography.Title>
          </div>
          <div className="sec-2">
            <Typography.Text type="secondary">CONTACT DETAILS</Typography.Text>
            <div>
              <p>
                Email : <span>{singleData && singleData.eMail}</span>
              </p>
              <p>
                Phone : <span>{singleData && singleData.mobile}</span>
              </p>
              <p>
                Country : <span>-</span>
              </p>
              <p>
                City : <span>-</span>
              </p>
            </div>
          </div>
          <Divider type="vertical" />
          <div className="sec-2">
            <Typography.Text type="secondary">DEMOGRAPHICS</Typography.Text>
            <div>
              <p>
                Date of Birth :{" "}
                <span>
                  {singleData && singleData.DateOfBirth !== null
                    ? moment(singleData.DateOfBirth).format("Do MM Y")
                    : "-"}
                </span>
              </p>
              <p>
                Gender :{" "}
                <span>
                  {singleData && singleData.gender === "M"
                    ? "Male"
                    : singleData && singleData.gender === "F"
                    ? "Female"
                    : "-"}
                </span>
              </p>
              <p>
                Type : <span>{singleData && singleData.userType}</span>
              </p>
              <p>
                Vendor Name : <span>{singleData && singleData.vendorName}</span>
              </p>
            </div>
          </div>
          <Divider type="vertical" />
          <div className="sec-2">
            <Typography.Text type="secondary">OTHER INFO</Typography.Text>
            <div>
              <p>
                ID : <span>{id}</span>
              </p>
              <p>
                Member Since :{" "}
                <span>
                  {singleData && singleData.memberSince !== null
                    ? moment(singleData.memberSince).format("Do MM Y")
                    : "-"}
                </span>
              </p>
              <p>
                Base Vendor :{" "}
                <span>{singleData && singleData.base_vendor}</span>
              </p>
            </div>
          </div>
        </div> */}

        <Tabs
          defaultActiveKey='1'
          tabBarGutter={60}
          style={{ fontSize: '1.25rem' }}
          animated={{ inkBar: true, tabPane: true }}
        >
          <TabPane tab='History' key='1'>
            <Row gutter={[15, 15]} className='history-row'>
              {/* <Col xs={24} md={8}>
                <div className='graph-card'>
                  <div className='heading'>
                    <Typography.Title level={5}>Discount V/S Full Purchase Orders</Typography.Title>
                    <Typography.Text className='desc' type='secondary'>
                      This chart is showing the bifurcation of individual customer transactions base
                      between purchases which were done on full price and purchases done on
                      discounted price
                    </Typography.Text>
                  </div>
                  <Donought Data={dicountPie && dicountPie} />
                </div>
              </Col> */}
              {/* <Col xs={24} md={8}>
                <div className='graph-card'>
                  <div className='heading'>
                    <Typography.Title level={5}>Top 5 Products</Typography.Title>
                    <Typography.Text className='desc' type='secondary'>
                      This chart is showing the sales of top 5 most purchased products. This is the
                      flagship bucket of that customer.
                    </Typography.Text>
                  </div>
                  <Donought Data={topProductGraph} />
                </div>
              </Col> */}
              {/* {mode !== 'offline' && (
                <Col xs={24} md={8}>
                  <div className='graph-card'>
                    <div className='heading'>
                      <Typography.Title level={5}>
                        Customer’s Category wise spending
                      </Typography.Title>
                      <Typography.Text className='desc' type='secondary'>
                        This chart is showing the individual customer’s spending on various
                        categories. This shows the tendency and preference of customer toward each
                        category spending
                      </Typography.Text>
                    </div>
                    <Donought Data={spendingGraph && spendingGraph} />
                  </div>
                </Col>
              )} */}

              <Col xs={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Top 5 Products</Typography.Title>
                  <Table
                    columns={productColumns}
                    // loading = {defaultData && defaultData.length>0 ? false : true}
                    dataSource={
                      topProducts &&
                      topProducts.length > 0 &&
                      topProducts.map((data, index) => ({
                        name: data.productName,
                        key: index,
                        price: data.price,
                        quantity: data.count,
                      }))
                    }
                    pagination={false}
                    scroll={{ x: 600 }}
                  />
                </div>
              </Col>

              {/* <Col xs={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Product Buying Frequency</Typography.Title>
                  <BarChart data={productBar && productBar} fields={['product', 'count']} />
                </div>
              </Col> */}

              <Col xs={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Product Frequency Table</Typography.Title>

                  <Table
                    columns={productColumns}
                    // loading = {defaultData && defaultData.length>0 ? false : true}
                    dataSource={
                      productFrequency &&
                      productFrequency.length > 0 &&
                      productFrequency.map((data, index) => ({
                        name: data.productName,
                        key: index,
                        price: data.price,
                        quantity: data.count,
                      }))
                    }
                    pagination={{
                      position: ['bottomCenter'],
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    scroll={{ x: 700 }}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={[50, 50]} justify='space-between'>
              {/* <Col xs={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Purchase Statistics</Typography.Title>
                  <LineChart data={orderBar} />
                </div>
              </Col> */}
              <Col xs={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Complete Order Details</Typography.Title>

                  <Row
                    // gutter={[50, 50]}
                    // justify="space-between"
                    style={{ margin: '1.25rem 0' }}
                  >
                    <Col xs={24} md={8}>
                      <div style={{ marginBottom: '1.25rem' }}>
                        <span
                          style={{
                            marginRight: '0.625rem',
                            fontSize: '0.875rem',
                          }}
                        >
                          Filter Orders by Date :
                        </span>
                        <br />
                        <DatePicker.RangePicker allowClear onChange={dateOnChange} />
                      </div>
                    </Col>
                    <Col xs={24} md={8}>
                      <div
                      // style={{ marginBottom: "1.25rem" }}
                      >
                        <span style={{ fontSize: '0.875rem' }}>Filter by Months :</span>
                        <br />
                        <Select
                          style={{ width: '23.125rem' }}
                          // defaultValue="none"
                          // value={monthsFilter}
                          placeholder='Select Range'
                          // allowClear
                          onChange={(value) => {
                            if (value) {
                              monthlyRangeSummary(value)
                            } else {
                              resetMonthlyFilter()
                            }
                          }}
                          // showSearch
                          allowClear
                          // showArrow
                        >
                          <Select.Option disabled value='none'>
                            Select Months Range
                          </Select.Option>
                          <Select.Option value={3}>3 months</Select.Option>
                          <Select.Option value={6}>6 months</Select.Option>
                          <Select.Option value={12}>1 year</Select.Option>
                        </Select>
                      </div>
                    </Col>
                    <Col xs={24} md={8}>
                      <div>
                        <span
                          style={{
                            marginRight: '0.625rem',
                            fontSize: '0.875rem',
                          }}
                        >
                          Filter Orders Monthly :
                        </span>
                        <br />
                        <Select
                          style={{
                            width: '18.75rem',
                            margin: '0 0.625rem 1.25rem 0',
                          }}
                          // defaultValue="none"
                          value={monthsFilter}
                          placeholder='Select Month'
                          // allowClear
                          onChange={(value) => {
                            if (value.length <= 3) {
                              setMonthsFilter(value)
                            }
                            // else if (value.length === 0) {
                            //   monthlySummary();
                            // }
                            else {
                              swal('', '3 or less months can be selected', 'warning')
                            }
                          }}
                          mode='multiple'
                          // showSearch
                          showArrow
                        >
                          <Select.Option disabled value='none'>
                            Select Month
                          </Select.Option>
                          <Select.Option value='01'>January</Select.Option>
                          <Select.Option value='02'>February</Select.Option>
                          <Select.Option value='03'>March</Select.Option>
                          <Select.Option value='04'>April</Select.Option>
                          <Select.Option value='05'>May</Select.Option>
                          <Select.Option value='06'>June</Select.Option>
                          <Select.Option value='07'>July</Select.Option>
                          <Select.Option value='08'>August</Select.Option>
                          <Select.Option value='09'>September</Select.Option>
                          <Select.Option value='10'>October</Select.Option>
                          <Select.Option value='11'>November</Select.Option>
                          <Select.Option value='12'>December</Select.Option>
                        </Select>

                        {reset ? (
                          <Button
                            type='primary'
                            onClick={() => {
                              setMonthsFilter([])
                              resetMonthlyFilter()
                              setReset(false)
                            }}
                          >
                            Reset
                          </Button>
                        ) : (
                          <Button
                            type='primary'
                            disabled={monthsFilter && monthsFilter.length > 0 ? false : true}
                            onClick={() => {
                              monthlySummary()
                              setReset(true)
                            }}
                          >
                            Filter
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Table
                    columns={columns}
                    dataSource={userOrders?.map((data) => ({
                      invoiceId: data.invoiceId || data.invoiceNo,
                      invoiceNumber: data.invoiceNo,
                      invoiceDate: moment(data.dated).format('Do MMM YYYY, h:mm a'),
                      netTotal: Math.round(data.netTotal).toLocaleString(),
                      total: Math.round(data.invoiceTotal).toLocaleString(),
                      // netTotal:
                      //   mode === "offline"
                      //     ? calculateSingleAmount(data.products)
                      //     : data.netTotal === 0
                      //     ? amountFormater(data.invoiceTotal)
                      //     : amountFormater(data.netTotal),
                      // total:
                      //   mode === "offline"
                      //     ? calculateSingleAmount(data.products)
                      //     : amountFormater(data.invoiceTotal),
                      detail: (
                        <InvoiceModal Data={data?.products} id={data?.invoiceNo} mode={mode} />
                      ),
                      key: data.id,
                    }))}
                    pagination={{
                      position: ['bottomCenter'],
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    scroll={{ x: 'auto' }}
                  />
                </div>
              </Col>

              <Col sm={24} md={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Discounted Orders</Typography.Title>
                  <Table
                    columns={columns}
                    // loading = {defaultData && defaultData.length>0 ? false : true}
                    dataSource={discountOrders?.map((data) => ({
                      invoiceNumber: data.invoiceNo,
                      invoiceDate: moment(data.dated).format('Do MMM YYYY, h:mm a'),
                      netTotal:
                        data.netTotal === 0
                          ? Math.round(data.invoiceTotal).toLocaleString()
                          : Math.round(data.netTotal).toLocaleString(),
                      total: Math.round(data.invoiceTotal).toLocaleString(),
                      detail: <InvoiceModal Data={data.products} id={data.invoiceNo} mode={mode} />,
                      key: data.invoiceDetailId,
                    }))}
                    pagination={{
                      position: ['bottomCenter'],
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    scroll={{ x: 'auto' }}
                  />
                </div>
              </Col>
              <Col sm={24} md={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Full Payment Orders</Typography.Title>
                  <Table
                    columns={columns}
                    // loading = {defaultData && defaultData.length>0 ? false : true}
                    dataSource={
                      fullOrders &&
                      fullOrders.length > 0 &&
                      fullOrders.map((data) => ({
                        invoiceId: data?.invoiceId,
                        invoiceNumber: data.invoiceNo,
                        invoiceDate: moment(data.dated).format('Do MMM YYYY, h:mm a'),
                        netTotal:
                          data.netTotal === 0
                            ? Math.round(data.invoiceTotal).toLocaleString()
                            : Math.round(data.netTotal).toLocaleString(),
                        total: Math.round(data.invoiceTotal).toLocaleString(),
                        detail: (
                          <InvoiceModal Data={data.products} id={data.invoiceNo} mode={mode} />
                        ),
                        key: data.invoiceDetailId,
                      }))
                    }
                    pagination={{
                      position: ['bottomCenter'],
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    scroll={{ x: 'auto' }}
                  />
                </div>
              </Col>
              <Col sm={24} md={24}>
                <div className='graph-card'>
                  <Typography.Title level={4}>Refunded Orders</Typography.Title>
                  <Table
                    columns={columns}
                    // loading = {defaultData && defaultData.length>0 ? false : true}
                    dataSource={refundedOrders?.map((data) => ({
                      invoiceNumber: data.invoiceNo,
                      invoiceDate: moment(data.dated).format('Do MMM YYYY, h:mm a'),
                      netTotal:
                        data.netTotal === 0
                          ? Math.round(data.invoiceTotal).toLocaleString()
                          : Math.round(data.netTotal).toLocaleString(),
                      total: Math.round(data.invoiceTotal).toLocaleString(),
                      detail: <InvoiceModal Data={data.products} id={data.invoiceNo} mode={mode} />,
                      key: data.invoiceDetailId,
                    }))}
                    pagination={{
                      position: ['bottomCenter'],
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    scroll={{ x: 'auto' }}
                  />
                </div>
              </Col>
            </Row>
          </TabPane>

          <TabPane tab='Predictions' key='2'>
            <div className='graph-card'>
              <Typography.Title level={4}>
                User Spendings in the next 15,30,60,90 Days & 1 Year.(from Last Purchase Date)
              </Typography.Title>
              <LineChart Orders={orderBar} Predictions={predictionGraph} />
            </div>
            <Typography.Title level={4}>
              User Spendings in the next 15,30,60,90 Days & 1 Year.(from Last Purchase Date)
            </Typography.Title>
            <Row className='top-stats graph-card' gutter={[30, 30]}>
              {predictPrice &&
                predictPrice.length > 0 &&
                predictPrice.map((data, i) => (
                  <Col xs={24} md={12} key={i} lg={i === predictPrice.length - 1 ? 24 : 6}>
                    <div className='stats'>
                      <Typography.Title level={5}>
                        Date : {data.day}{' '}
                        {i === predictPrice.length - 1 && '( 1 Year after Purchase Date )'}
                      </Typography.Title>
                      <Typography.Text>Rs. {data.price}</Typography.Text>
                    </div>
                  </Col>
                ))}
            </Row>
            {/* <BarChart
              data={predictPrice && predictPrice}
              fields={["day", "price"]}
            /> */}
            <Typography.Title level={4}>
              User Purchasing Quantity in the next 15,30,60,90 Days & 1 Year.(from Last Purchase
              Date)
            </Typography.Title>
            <Row className='top-stats graph-card' gutter={[30, 30]}>
              {predictQuantity &&
                predictQuantity.length > 0 &&
                predictQuantity.map((data, i) => (
                  <Col key={i} xs={24} md={12} lg={i === predictQuantity.length - 1 ? 24 : 6}>
                    <div className='stats'>
                      <Typography.Title level={5}>
                        Date : {data.day}{' '}
                        {i === predictQuantity.length - 1 && '( 1 Year after Purchase Date )'}
                      </Typography.Title>
                      <Typography.Text>{data.quantity} units</Typography.Text>
                    </div>
                  </Col>
                ))}
            </Row>
            {/* <BarChart
              data={predictQuantity && predictQuantity}
              fields={["day", "quantity"]}
            /> */}
          </TabPane>
          <TabPane tab='Feedbacks' key='3'>
            <div
              className='campaign-tabs campaign-container'
              style={{ width: '100%', marginTop: '0px' }}
            >
              <div className='main-container-feedback'>
                <Row gutter={[15, 30]} style={{ width: '100%', justifyContent: 'center', gap: 25 }}>
                  <Col
                    xs={24}
                    lg={15}
                    style={{
                      background: 'white',
                      borderRadius: '10px',
                      padding: '40px',
                    }}
                  >
                    <h1
                      style={{
                        textAlign: 'center',
                        paddingBottom: '30px',
                        paddingTop: '30px',
                      }}
                    >
                      Latest Feedback
                    </h1>
                    {questions?.map((data, index) => {
                      return (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            marginBottom: 20,
                          }}
                          key={index}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '16px',
                            }}
                          >
                            <p>{index + 1}</p>
                            <p
                              style={{
                                paddingLeft: '20px',
                              }}
                            >
                              {data.question}
                            </p>
                          </div>
                          <div
                            style={{
                              fontSize: '16px',
                              width: '50%',
                            }}
                          >
                            <Tooltip
                              title={`Negative: ${(
                                calculatePercentage(data?.question, 1) +
                                calculatePercentage(data?.question, 2)
                              )?.toFixed(2)}% | Neutral: ${calculatePercentage(
                                data?.question,
                                3,
                              )?.toFixed(2)}% | Positive: ${(
                                calculatePercentage(data?.question, 4) +
                                calculatePercentage(data?.question, 5)
                              )?.toFixed(2)}% `}
                            >
                              {/* <Progress
                            type='line'
                            showInfo={false}
                            // strokeColor={{
                            //   [`${calculatePercentage(data?.question, 1) + calculatePercentage(data?.question, 2)}%`]: 'red',
                            //   [`${calculatePercentage(data?.question, 1) + calculatePercentage(data?.question, 2) + calculatePercentage(data?.question, 3)}%`]: 'orange',
                            //   [`${calculatePercentage(data?.question, 1) + calculatePercentage(data?.question, 2) + calculatePercentage(data?.question, 3) + calculatePercentage(data?.question, 4) + calculatePercentage(data?.question, 5)}%`]: 'green',
                            // }}
                            strokeColor={{
                              '0%': 'red',
                              '50%': 'orange',
                              '100%': 'green',
                            }}
                            strokeWidth={15}
                            percent={100}
                          /> */}
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  width: '100%',
                                  height: '15px',
                                  background: 'linear-gradient(to right, red, orange, green)',
                                  transition: 'all 0.5s ease-in-out',
                                  borderRadius: '20px',
                                }}
                              >
                                <div
                                  style={{
                                    width: [
                                      `${
                                        calculatePercentage(data?.question, 1) +
                                        calculatePercentage(data?.question, 2)
                                      }%`,
                                    ],
                                    height: '15px',
                                    background: '#C1445F',
                                    borderTopLeftRadius: '20px',
                                    borderBottomLeftRadius: '20px',
                                  }}
                                ></div>
                                <div
                                  style={{
                                    width: [`${calculatePercentage(data?.question, 3)}%`],
                                    height: '15px',
                                    background: '#FDAA10',
                                  }}
                                ></div>
                                <div
                                  style={{
                                    width: [
                                      `${
                                        calculatePercentage(data?.question, 4) +
                                        calculatePercentage(data?.question, 5)
                                      }%`,
                                    ],
                                    height: '15px',
                                    background: '#037D7C',
                                    borderTopRightRadius: '20px',
                                    borderBottomRightRadius: '20px',
                                  }}
                                ></div>
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      )
                    })}
                  </Col>
                  <Col
                    xs={24}
                    lg={8}
                    style={{
                      background: 'white',
                      borderRadius: '10px',
                      marginLeft: '20px',
                    }}
                  >
                    <h1
                      style={{
                        textAlign: 'center',
                        paddingBottom: '20px',
                        paddingTop: '30px',
                        position: 'sticky',
                      }}
                    >
                      Comments
                    </h1>
                    <div
                      style={{
                        display: 'block',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '20px',
                        overflowY: 'scroll',
                        height: '25rem',
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgba(255, 0, 0, 0.5) rgba(0, 0, 255, 0.5)',
                      }}
                    >
                      {comments?.map((data, index) => {
                        return (
                          <div key={index}>
                            <h4>{data.date}</h4>
                            <p
                              style={{
                                textAlign: 'justify',
                              }}
                            >
                              {data.comments}
                            </p>
                          </div>
                        )
                      })}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </TabPane>
          {['897', '1003'].includes(vendorId) && (
            <TabPane tab='Loyalty' key='4'>
              <div
                className='campaign-tabs campaign-container'
                style={{ width: '100%', marginTop: '0px' }}
              >
                <div className='main-container-feedback'>
                  <Row style={{ width: '100%', justifyContent: 'center' }}>
                    <Col xs={24}>
                      <Table columns={LoyaltyColumns} dataSource={LoyaltyData} />
                    </Col>
                    <Col xs={24}>
                      <Table columns={LoyaltyInvoiceColumns} dataSource={LoyaltyInvoiceData} />
                    </Col>
                  </Row>
                </div>
              </div>
            </TabPane>
          )}
        </Tabs>
      </div>
    </div>
  )
}

export default CustomerDetails
